import React, { useCallback, useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IBpaContext, BpaContext } from '../../bpaState/bpaContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { useHistory } from 'react-router-dom';
import { convertUndefinedFields } from 'utils/helpers';
import { updateCustomerBPA } from 'backend/customers';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IBpaContext>(BpaContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleRedirect = useCallback(() => {
		history.push('/clients/customers');
	}, [history]);

	const handleSubmit = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateCustomerBPA(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [changeTypeOfModalWindow, showLoader, hideLoader, dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleSubmit}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};
